import React from "react";
import { Globe, Lock, Shield, Trash2 } from "lucide-react";
import { timeAgo } from "../../../lib/streamParse";

const Loading = () => <div className="space-y-2">{[0, 1, 2].map((i) => <div key={i} className="h-14 rounded-lg shimmer border border-slate-200" />)}</div>;
const Empty = ({ children, testid }) => <div className="rounded-xl border border-dashed border-slate-200 py-10 px-6 text-center text-sm text-slate-500" data-testid={testid}>{children}</div>;

const DelBtn = ({ onClick, testid }) => (
  <button onClick={onClick} data-testid={testid} aria-label="Delete" className="opacity-0 group-hover:opacity-100 text-slate-500 hover:text-rose-600 transition-opacity"><Trash2 size={13} /></button>
);

export const RecordList = ({ rows, onRemove }) => {
  if (rows === null) return <Loading />;
  if (!rows.length) return <Empty testid="db-records-empty">No records in this collection.</Empty>;
  return (
    <div className="space-y-2" data-testid="db-records">
      {rows.map((r, i) => (
        <div key={r.id} className="group rounded-lg border border-slate-200 bg-white p-3" data-testid={`db-record-${i}`}>
          <div className="flex items-center gap-2 text-[11px] font-mono text-slate-500 mb-1.5">
            {r.public ? <span className="flex items-center gap-1 text-emerald-600"><Globe size={10} /> public</span> : <span className="flex items-center gap-1"><Lock size={10} /> private</span>}
            <span>· {r.owner_name || (r.created_by === "owner" ? "you" : "visitor")}</span>
            <span>· {timeAgo(r.created_at)}</span>
            <span className="ml-auto"><DelBtn onClick={() => onRemove(r)} testid={`db-record-delete-${i}`} /></span>
          </div>
          <pre className="text-[11px] font-mono text-slate-700 whitespace-pre-wrap break-all max-h-40 overflow-hidden">{JSON.stringify(r.data, null, 2)}</pre>
        </div>
      ))}
    </div>
  );
};

export const UserList = ({ rows, onRemove }) => {
  if (rows === null) return <Loading />;
  if (!rows.length) return <Empty testid="db-users-empty">Nobody has signed up yet. Accounts created in your app appear here.</Empty>;
  return (
    <div className="rounded-xl border border-slate-200 divide-y divide-slate-200" data-testid="db-users">
      {rows.map((u, i) => (
        <div key={u.id} className="group flex items-center gap-3 px-4 h-12 text-sm" data-testid={`db-user-${i}`}>
          <span className="w-7 h-7 rounded-full bg-slate-100 text-xs text-slate-600 flex items-center justify-center">{(u.name || u.email).charAt(0).toUpperCase()}</span>
          <span className="flex-1 min-w-0 truncate text-slate-700">{u.name} <span className="text-slate-500 font-mono text-xs">{u.email}</span></span>
          {u.role === "admin" && <span className="flex items-center gap-1 text-[10px] font-mono text-indigo-600"><Shield size={10} /> admin</span>}
          <span className="text-xs text-slate-400">{timeAgo(u.created_at)}</span>
          {u.role !== "admin" && <DelBtn onClick={() => onRemove(u)} testid={`db-user-delete-${i}`} />}
        </div>
      ))}
    </div>
  );
};
